import { StripeProductType } from '../app/core/stripe/product.stripe';
import { StageType } from './stage-type';

export const environment = {
  production: true,
  isConnectToBackend: true,
  isDebugMode: false,
  stageType: StageType.staging,

  isE2e: false,

  textFieldDebounceTime: 32,

  enableNextTaskDetail: true,

  accessToken: '',

  domain: 'https://beta.peakmojo.ai',

  filesDomain: 'https://files-staging.peakmojo.ai',

  ec2Url: '<TODO>',

  lambdaWebsiteUrl: 'https://hpuc5fjfvjmu32bcewbuadawl40fsyga.lambda-url.us-east-1.on.aws/',
  lambdaWebsitePublicUrl: 'https://lgphlsh3n4m5shsnq3dwgz6hnu0fgwax.lambda-url.us-east-1.on.aws/',
  openaiUrl: 'https://z7kvj6qg4flcrod2sxnxzdgfpe0xtyvf.lambda-url.us-east-1.on.aws/',

  lambdaWebSocketUrl: 'wss://c1ob4zlui8.execute-api.us-east-1.amazonaws.com/staging',

  clerkKey: 'pk_test_bGl0ZXJhdGUtYWRkZXItODMuY2xlcmsuYWNjb3VudHMuZGV2JA',
  clerkDomain: 'literate-adder-83.clerk.accounts.dev',

  sentry: 'https://98a6207873a2f122863cf2920edbd267@o4507523742433280.ingest.us.sentry.io/4507524663607296',
  posthog: 'phc_kUYibN8ruyybTud8LTvU8D0qghVsLyjSXP1HkCg14VT',

  posthogSurvey: {
    sessionEndSurvey: '0190dd5a-8abb-0000-beb4-7bd5c1cf8172',
  },

  supportEmail: 'hello@peakmojo.ai',

  stripe: {
    pricingTableId: 'prctbl_1Q9FagRxbnIIrwvoBjiqtG8S',
    publishableKey:
      'pk_test_51Q8SSpRxbnIIrwvoV6bOiZpPAyLvMiVKJpTA2h5LVn1lErk0jA7Xg9XiwiQfBhcx43cdACzNiBWNvg8NRJlVPQWE00fDGnGv8H',

    productList: [
      {
        id: 'prod_R1I9NFMsA8Sd7b',
        type: StripeProductType.basic,
        name: 'Basic Plan',
        callLimitation: 40,
      },
      {
        id: 'prod_R1I9Y1tQGljbKv',
        type: StripeProductType.premium,
        name: 'Premium Plan',
        callLimitation: 150,
      },
    ],
  },
};
